/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/daily_revenue_by_purchase_names" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsAppGroupIdChartsDailyRevenueByPurchaseNames } from "./constants";
import type { AppsAppGroupIdChartsDailyRevenueByPurchaseNamesResult } from "./types";

export const getAppsAppGroupIdChartsDailyRevenueByPurchaseNames = reactQueryFetcherAdapter(
  appsAppGroupIdChartsDailyRevenueByPurchaseNames,
  (
    signal: AbortSignal,
    appGroupId: string,
    appIds: string[],
    startDate: number,
    endDate: number,
    keys: string[]
  ): Promise<AppsAppGroupIdChartsDailyRevenueByPurchaseNamesResult> => {
    return fetch(
      `/apps/${appGroupId}/charts/daily_revenue_by_purchase_names`,
      "GET",
      { app_ids: appIds, start_date: startDate, end_date: endDate, keys },
      { signal }
    );
  }
);
